/**
 * Party rows configurable per email modal (admin Default email recipients).
 * Extend when adding a modal with a non-standard party list (see SendPdfEmailDialog).
 */
import { accountTypes } from 'config/user.type.constants'
import { closingPartiesMap, partiesMap, partiesMapWithAccountTypes } from 'reducers/loanDetail.reducer'

import type { EmailModalId } from './emailModalDefaults.constants'

function sortedUnique(labels: string[]): string[] {
  return Array.from(new Set(labels)).sort((a, b) => a.localeCompare(b))
}

/** Full grid used by most `loadParties` modals (approximate superset). */
export function buildDefaultAdminPartyLabels(): string[] {
  const s = new Set<string>(['Borrower', 'CoBorrower', 'E-Mail Notification Contacts', 'New Email'])
  Object.values(partiesMap).forEach((x) => s.add(x))
  Object.values(closingPartiesMap).forEach((x) => s.add(x))
  Object.values(accountTypes).forEach((x) => s.add(x))
  return Array.from(s).sort((a, b) => a.localeCompare(b))
}

export function getPartyLabelsForEmailModal(modalId: EmailModalId): string[] {
  if (modalId === 'loanSubmissionSendPdfEmail') {
    return sortedUnique([
      ...Object.values(partiesMapWithAccountTypes()),
      'Borrower',
      'CoBorrower',
      'E-Mail Notification Contacts',
      'Loan Setup',
      'Closer',
      'New Email',
    ])
  }
  return buildDefaultAdminPartyLabels()
}
